import { chunkEvery, uniqueBy } from '@realadvisor/array';

// The Hasura agent role returns at most 50 users per query.
export const USER_BATCH_SIZE = 50;

export const getSelectedUserOptions = <User extends { id: string }>(
  ids: readonly string[],
  users: readonly User[] | undefined,
  fallback: (id: string) => User,
): User[] => {
  const byId = new Map<string, User>();
  for (const user of users ?? []) {
    if (!byId.has(user.id)) {
      byId.set(user.id, user);
    }
  }
  return ids.map(id => byId.get(id) ?? fallback(id));
};

export const loadSelectedUsers = async <User>(
  ids: readonly string[],
  loadBatch: (ids: string[]) => Promise<readonly User[]>,
): Promise<User[]> => {
  const uniqueIds = uniqueBy(ids, id => id);
  const users: User[] = [];
  for (const batch of chunkEvery(uniqueIds, USER_BATCH_SIZE)) {
    users.push(...(await loadBatch([...batch])));
  }
  return users;
};
